module.exports = __webpack_public_path__ + "img/jumpRight3.41cd91f9.png";